
import { AppConstants } from "../../../../core/constants/constants";
import LocationDetails from "../../domain/entities/LocationDetails";
import Search from "../../domain/entities/Search";
import {
	VerificationLivenessSession,
	VerificationUploadResult,
} from "../../domain/entities/VerificationUploadResult";
import { SettingsRepository } from "../../domain/repositories/SettingsRepository";
import { SettingsDataSource } from "../datasource/SettingsDataSource";

export class SettingsRepositoryImpl implements SettingsRepository {
	constructor(private dataSource: SettingsDataSource) {}


	getPlaces(search: string): Promise<Search[]> {
		return AppConstants.getRightOrLeftSide<Search[]>(
			this.dataSource.getPlaces(search)
		)
	}

	getDetailsPlace(place_id: string): Promise<LocationDetails> {
		return AppConstants.getRightOrLeftSide<LocationDetails>(
			this.dataSource.getDetailsPlace(place_id)
		)
	}

	getVerificationCode(): Promise<string> {
		return AppConstants.getRightOrLeftSide<string>(
			this.dataSource.getVerificationCode()
		);
	}
	sendVerificationPhoto(
		file: File,
		code: string
	): Promise<VerificationUploadResult> {
		return AppConstants.getRightOrLeftSide<VerificationUploadResult>(
			this.dataSource.sendVerificationPhoto(file, code)
		);
	}

	createVerificationLivenessSession(): Promise<VerificationLivenessSession> {
		return AppConstants.getRightOrLeftSide<VerificationLivenessSession>(
			this.dataSource.createVerificationLivenessSession()
		);
	}

	saveVerificationLivenessResult(sessionId: string): Promise<string> {
		return AppConstants.getRightOrLeftSide<string>(
			this.dataSource.saveVerificationLivenessResult(sessionId)
		);
	}

	createAdminLiveFaceSession(): Promise<VerificationLivenessSession> {
		return AppConstants.getRightOrLeftSide<VerificationLivenessSession>(
			this.dataSource.createAdminLiveFaceSession()
		);
	}

	saveAdminLiveFaceResult(sessionId: string): Promise<string> {
		return AppConstants.getRightOrLeftSide<string>(
			this.dataSource.saveAdminLiveFaceResult(sessionId)
		);
	}
}
